// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"fX-z","sponsoredTooltipWrapper":"gX-z","sponsoredTooltip":"hX-z","newCard":"iX-z"};